/**
 * Floating Vue Plugin Configuration
 *
 * Provides tooltip and dropdown functionality using floating-ui.
 * Used for price deviation tooltips in checkout flow.
 */

import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

/**
 * Custom tooltip styles
 * Override default floating-vue styles for white background with dark text
 */
const customStyles = document.createElement('style');
customStyles.textContent = `
  .v-popper--theme-tooltip .v-popper__inner {
    background: #ffffff;
    color: #1f2937;
    border: 1px solid #e5e7eb;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  }

  .v-popper--theme-tooltip .v-popper__arrow-outer {
    border-color: #e5e7eb;
  }

  .v-popper--theme-tooltip .v-popper__arrow-inner {
    visibility: visible;
    border-color: #ffffff;
  }
`;
document.head.appendChild(customStyles);

export default FloatingVue;

/**
 * Floating Vue configuration options
 *
 * @remarks
 * - tooltip theme configured for both desktop (hover) and mobile (touch)
 * - focus trigger ensures keyboard accessibility
 */
export const floatingVueConfig = {
  themes: {
    tooltip: {
      // Triggers for desktop and touch devices
      triggers: ['hover', 'focus', 'touch'],
      hideTriggers: ['mouseleave', 'blur'],
      delay: {
        show: 200,
        hide: 100,
      },
    },
  },
};
